interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} gap-3`}>
      {kicker ? (
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium tracking-wide text-primary-700">
          <i className="ri-flashlight-fill" aria-hidden="true" />
          {kicker}
        </span>
      ) : null}
      <h2 className="font-display text-2xl leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}